import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
const SITE_TITLE = "JAG Medical Solutions | Medical Modality Equipment";
const SITE_DESCRIPTION = "Compare therapeutic modalities, product categories, training, and implementation support for chiropractic, rehab, and wellness practices.";
function setMetadata(name: string, content: string, property = false) {
  const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(property ? "property" : "name", name);
    document.head.appendChild(element);
  }
  element.content = content;
}
document.title = SITE_TITLE;
setMetadata("description", SITE_DESCRIPTION);
setMetadata("og:title", SITE_TITLE, true);
setMetadata("og:description", SITE_DESCRIPTION, true);
setMetadata("twitter:title", SITE_TITLE);
setMetadata("twitter:description", SITE_DESCRIPTION);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-276" data-mp="15lkbyilazl18" />);
}